import React from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import { DtpPanel } from 'dtp-react-components';
import { Grid, SimpleGrid } from '../../../components/index';
import * as listUtils from '../../../utils/listsSelect';
import { formatarValor, formatarCnpj } from '../../../utils/helpers';

class InfoPagamentoRGPS extends React.Component {
  getTagStatus() {
    const listaEstados = listUtils.estadosPagamento;
    if (this.props.estadoFormulario.infoPagamento.idControlePagamento) {
      let estadoCss = '';
      switch (this.props.estadoFormulario.infoPagamento.estado) {
        case 1:
          estadoCss = 'estadoAberto';
          break;
        case 2:
          estadoCss = 'estadoEmProcessamento';
          break;
        case 3:
          estadoCss = 'estadoContestado';
          break;
        case 4:
          estadoCss = 'estadoAguardandoAnaliseDefesa';
          break;
        case 5:
          estadoCss = 'estadoPago';
          break;
        case 6:
          estadoCss = 'estadoRejeitado';
          break;
        case 7:
          estadoCss = 'estadoNaoPago';
          break;
        case 8:
          estadoCss = 'estadoNaoMonitorado';
          break;
        case 9:
          estadoCss = 'estadoEmAnaliseDefesaRegularidadePagamento';
          break;
        case 10:
          estadoCss = 'estadoEmAnaliseDefesaGru';
          break;
        case 11:
          estadoCss = 'estadoEmAnaliseDefesaExtraordinaria';
          break;
        case 12:
          estadoCss = 'estadoContestacaoExtraordinaria';
          break;
        default: estadoCss = '';
      }

      return (
        <div
          className={estadoCss}
          style={{
            textAlign: 'center',
            fontSize: '12px',
            maxWidth: 'inherit',
            padding: '5px 7px 5px 7px',
            minHeight: 'inherit',
          }}
        >
          {listUtils.getObject(listaEstados, this.props.estadoFormulario.infoPagamento.estado).label}
        </div>
      );
    }
    return (<div>.</div>);
  }
  textoDestaque = texto => (
    (<span style={{ fontWeight: '600' }}>{texto}</span>)
  )

  textoInformativo = texto => (
    (<span style={{ fontWeight: '500' }}>{texto}</span>)
  )

// formatarValor = (valor) => {
//   let valorFormatado = '0.0';
//   if ((valor !== undefined) && (valor !== null)) {
//     const formato = {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 3,
//       style: 'currency',
//       currency: 'BRL',
//     };
//     if (valor === 0 || valor === '') {
//       return 'R$ 0,00';
//     }
//     valorFormatado = valor.toLocaleString('pt-BR', formato);
//   }
//   return valorFormatado;
// };

formatarCompetencia = (mes, ano) => {
  let objCompetencia = `${mes}/${ano}`;
  if (objCompetencia.length !== 7) {
    objCompetencia = `0${objCompetencia}`;
  }
  return objCompetencia;
};

buscaGruPelaData = (data, grusPagas) => {
  // const datas = this.props.estadoFormulario.infoPagamento.grusTO.filter(gru => (
  //   gru.dataVencimento === data
  // ));
  const datas = grusPagas.filter(gru => (
    gru.dataVencimento === data
  ));

  return datas;
}
// gru.situacao === 2
buscaRegistroComMaiorDataVencimento = () => {
  const grusPagas = this.props.estadoFormulario.infoPagamento.grusTO.filter(gru => gru.situacao === 2 && gru.dataPagamento !== undefined);
  const datas = Math.max(...grusPagas.map((gru) => {
    const dateString = gru.dataVencimento;
    const dateParts = dateString.split('/');
    const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return dateObject;
  }));

  return this.buscaGruPelaData(new Date(datas).toLocaleDateString(), grusPagas);
  // return this.buscaGruPelaData(gruPagaComMaiorData.dataVencimento);
}

render() {
  const rowStyle = {
    marginBottom: '10px',
    fontSize: '16px',
  };

  const infomativoStyle = {
    margin: '18px 0px 10px 0px',
    fontSize: '16px',
  };

  return (
    <DtpPanel title="Informações do Pagamento RGPS">
      <div style={{ float: 'right' }}>{this.getTagStatus()}</div>
      <div className="row" style={rowStyle}>
        <SimpleGrid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Pagador: ')}  {this.props.estadoFormulario.infoPagamento.nomeEntidadePagadora}</span>
          </Grid>
          <Grid cols="4 4 4 4">
            <span>{this.textoDestaque('CNPJ RPPS: ')}  {formatarCnpj(this.props.estadoFormulario.infoPagamento.cnpjPagador)}</span>
          </Grid>
        </SimpleGrid>
      </div>
      <div className="row" style={rowStyle}>
        <SimpleGrid>
          <Grid cols="7 7 7 7">
            <span>{this.textoDestaque('Recebedor: ')}  {this.props.estadoFormulario.infoPagamento.nomeEntidadeRecebedora}</span>
          </Grid>
        </SimpleGrid>
      </div>
      <div className="row" style={rowStyle}>
        <SimpleGrid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Competência: ')}
              {this.formatarCompetencia(this.props.estadoFormulario.infoPagamento.mes, this.props.estadoFormulario.infoPagamento.ano)}
            </span>
          </Grid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Valor: ')}  {formatarValor(this.props.estadoFormulario.infoPagamento.valorCompensacao)}</span>
          </Grid>
          <Grid cols="3 3 3 3">
            <span>{this.textoDestaque('Vencimento: ')}  {this.props.estadoFormulario.infoPagamento.dataVencimento} </span>
          </Grid>
        </SimpleGrid>
      </div>
      <SimpleGrid>
        <div className="row" style={rowStyle}>
          <Grid cols="3 3 3 3">
            <span>
              {this.textoDestaque('Débito carregado:')} {(this.props.estadoFormulario.infoPagamento.indicadorCobrancaCarregada === 1) ? 'Sim' : 'Não'}
            </span>
          </Grid>
          <Grid cols="7 7 7 7">
            {(this.props.estadoFormulario.infoPagamento.indicadorCobrancaCarregada === 1) ?
              <span>{this.textoDestaque('Valor débito carregado: ')}  {formatarValor(this.props.estadoFormulario.infoPagamento.valorCarregado)}</span>
            : ''}
          </Grid>
        </div>
      </SimpleGrid>
      {/* {this.props.estadoFormulario.infoPagamento.grusTO.filter(gru => gru.situacao === 2).map(element => ( */}
      {this.buscaRegistroComMaiorDataVencimento().map(element => (
        <SimpleGrid>
          <div className="row" style={rowStyle}>
            <Grid cols="3 3 3 3">
              <span>{this.textoDestaque('Multa: ')}  {formatarValor(element.valorMulta)}</span>
            </Grid>
            <Grid cols="3 3 3 3">
              <span>{this.textoDestaque('Juros: ')}  {formatarValor(element.valorJuros)} </span>
            </Grid>
            <Grid cols="4 4 4 4">
              <span>{this.textoDestaque('Valor do documento: ')}  {formatarValor(element.valorDocumento)}</span>
            </Grid>
          </div>
        </SimpleGrid>))
      // this.buscaRegistroComMaiorDataVencimento() moment(gru.dataVencimento, 'DD/MM/YYYY').toDate() >= moment(new Date().toLocaleDateString(), 'DD/MM/YYYY').toDate()
      }
      {this.props.estadoFormulario.infoPagamento.indicadorCobrancaCarregada === 1 ?
        <div className="row" style={infomativoStyle}>
          <SimpleGrid>
            <span>{this.textoInformativo('Esta cobrança foi carregada na versão 3.6.0 do Comprev, através de um levantamento de débitos feito pelo RGPS.' +
              ' Caso discorde do valor ou da cobrança, favor apresentar uma defesa de regularidade do pagamento para que seja analisada pelo RGPS.')}
            </span>
          </SimpleGrid>
        </div>
      : ''}
    </DtpPanel>
  );
}
}

InfoPagamentoRGPS.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default InfoPagamentoRGPS;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/infoPagamentoRGPS.jsx